import { INTERNAL_FLAGS } from './const/flags';

export const consoleLog = (log: any, isError?: boolean): void => {
  if (INTERNAL_FLAGS.ENABLE_LOG) {
    if (isError) {
      console.error(log, new Date());
    } else {
      if (typeof log === 'object') {
        console.info(log, new Date());
      } else {
        console.info('\x1b[33m%s\x1b[0m', log, new Date());
      }
    }
  }
};
